import m from "../../geodata/es2015/belizeLow";
window.am4geodata_belizeLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/belizeLow.js
// module id = null
// module chunks = 